import styled from "@emotion/styled";
import { m } from "framer-motion";
import { padding } from "polished";
import React from "react";

// This is redesigned to matching the Cookie Banner.

export const PartnerBarWrapper = styled.div(({ theme }) => {
  return {
    position: "fixed",
    left: 4,
    right: 4,

    maxWidth: 600,
    minHeight: 80,
    bottom: 20,

    width: "calc(100% - 10px)",
    maxHeight: "90%",
    margin: "0 auto",
    border: "0.5px solid rgba(0,0,0,.15)",
    borderRadius: 10,

    fontSize: 14,
    lineHeight: "20px",

    boxShadow: "0 5px 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(20px) saturate(5)",
    zIndex: theme.zIndex.STICKY_FOOTER,

    [theme.breakpoints.SML]: {
      maxWidth: "auto",
      bottom: 32,

      fontSize: 12,
      lineHeight: "16px",
    },
  };
});

export const PartnerBannerContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  padding: 16,

  [theme.breakpoints.SML]: {
    gap: 8,
    padding: 12,
  },
}));

export const PartnerLogoImage = styled.img(({ theme }) => ({
  maxWidth: 120,
  maxHeight: 40,
  borderRadius: 4,
  marginBottom: 4,

  [theme.breakpoints.SML]: {
    maxWidth: 96,
  },
}));

export const ReadMoreButton = styled.a({
  position: "absolute",
  right: 16,
  bottom: 16,
  lineHeight: "16px",
});

export const CloseIcon = styled.button(({ theme }) => ({
  position: "absolute",
  right: 12,
  top: 12,
  width: 24,
  height: 24,
  ...padding(4),
  border: "none",
  background: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "&:hover": {
    cursor: "pointer",
  },
  "&:focus": {
    outline: "none",
  },

  [theme.breakpoints.SML]: {
    right: 8,
    top: 8,
  },
}));

export const MotionDiv: React.FC<{
  name: string;
  children: React.ReactChild | React.ReactChild[];
}> = ({ children, name }) => {
  return (
    <m.div
      key={name}
      initial="collapsed"
      animate="open"
      exit="collapsed"
      variants={{
        open: {
          height: "auto",
          opacity: 1,
        },
        collapsed: {
          height: 0,
          opacity: 0,
        },
      }}
      transition={{ duration: 0.25, ease: [0.04, 0.62, 0.23, 0.98] }}
    >
      {children}
    </m.div>
  );
};
